import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
  /* Root container */
  root: {
    position: 'sticky',
    height: 'calc(100vh - 220px)',
    display: 'flex',
    flexDirection: 'column',
    borderRadius: 4,
    backgroundColor: '#FAFAFA',
    border: '1px solid #EEE',
  },

  /* Header / Tabs */
  header: {
    height: 48,
    boxSizing: 'border-box',
    borderBottom: '1px solid rgba(213, 214, 221, 1)',
    display: 'flex',
    justifyContent: 'start',
    alignItems: 'center',
  },
  tab: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 178,
    padding: 8,
    flexGrow: 1,
    cursor: 'pointer',
    borderBottom: 'none',
    marginBottom: 0,
  },
  tabActive: {
    borderBottom: '1px solid rgba(63, 81, 181, 1)',
    marginBottom: -7,
  },
  tabContent: {
    display: 'flex',
    justifyContent: 'start',
    alignItems: 'center',
    gap: 6,
  },
  tabIcon: {
    width: 20,
    height: 20,
    display: 'block',
  },
  tabLabel: {
    fontSize: 14,
    fontWeight: 400,
    color: '#78798E',
    fontStyle: 'normal',
    lineHeight: '24px',
    width: '100%',
    textAlign: 'center',
  },
  tabLabelActive: {
    color: 'rgba(63, 81, 181, 1)',
  },

  /* Content wrapper */
  content: {
    padding: 20,
  },
  sectionHeader: {
    display: 'flex',
    justifyContent: 'start',
    alignItems: 'center',
    gap: 12,
    marginBottom: 12,
  },
  sectionTitle: {
    fontSize: 14,
    fontWeight: 400,
    color: '#2B2C35',
    fontStyle: 'normal',
    lineHeight: '21px',
  },

  /* Grid rows */
  gridRow: {
    width: '100%',
  },
  gridCellLabel: {
    border: '1px solid #E9EBF5',
    padding: '8px 8px 8px 12px',
  },
  gridCellValue: {
    border: '1px solid #E9EBF5',
    borderLeft: '0.5px solid #E9EBF5',
    padding: '8px 8px 8px 12px',
  },
  gridTextLabel: {
    color: '#5F6071',
    fontSize: 14,
    fontWeight: 500,
    lineHeight: '17px',
    fontStyle: 'normal',
  },
  gridTextValue: {
    color: '#5F6071',
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '17px',
    fontStyle: 'normal',
    textOverflow: 'ellipsis',
    maxWidth: 300,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },

  /* Empty state */
  emptyStateWrap: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '40px 20px',
    textAlign: 'center',
  },
  emptyStateText: {
    fontSize: 14,
    fontWeight: 400,
    color: '#78798E',
    fontStyle: 'normal',
    lineHeight: '17px',
  },

  /* Row margin helpers to avoid inline styles */
  rowFirst: {
    marginTop: 0,
  },
  rowNotFirst: {
    marginTop: -1,
  },

  /* Radius helpers for first/last rows */
  cellTopLeft: {
    borderTopLeftRadius: 4,
  },
  cellBottomLeft: {
    borderBottomLeftRadius: 4,
  },
  cellTopRight: {
    borderTopRightRadius: 4,
  },
  cellBottomRight: {
    borderBottomRightRadius: 4,
  },

  /* --------- Responsiveness --------- */
  /* Base (>=1920px) is as above. Adjust down for common widths. */

  /* <= 1440px */
  '@media (max-width:1440px)': {
    tab: {
      width: 160,
      padding: 8,
    },
    tabLabel: {
      fontSize: 13,
    },
    sectionTitle: {
      fontSize: 13,
    },
    gridTextLabel: {
      fontSize: 13,
    },
    gridTextValue: {
      fontSize: 13,
    },
  },

  /* <= 1366px */
  '@media (max-width:1366px)': {
    content: {
      padding: 16,
    },
    tab: {
      width: 150,
    },
    tabLabel: {
      fontSize: 12,
      lineHeight: '22px',
    },
    sectionTitle: {
      fontSize: 12,
      lineHeight: '20px',
    },
    gridTextLabel: {
      fontSize: 12,
    },
    gridTextValue: {
      fontSize: 12,
    },
  },

  /* <= 1024px (tablet landscape) */
  '@media (max-width:1024px)': {
    header: {
      height: 44,
    },
    tab: {
      width: '50%',
      padding: 6,
    },
    tabIcon: {
      width: 18,
      height: 18,
    },
    tabLabel: {
      fontSize: 12,
      lineHeight: '20px',
    },
    content: {
      padding: 12,
    },
    gridCellLabel: {
      padding: '6px 6px 6px 10px',
    },
    gridCellValue: {
      padding: '6px 6px 6px 10px',
    },
    gridTextLabel: {
      fontSize: 12,
      lineHeight: '16px',
    },
    gridTextValue: {
      fontSize: 12,
      lineHeight: '16px',
    },
  },
  /* ---------- Added classes (converted from inline styles) ---------- */
  supplementalWrap: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    marginTop: 20,
    boxSizing: 'border-box',
  },
  emptySupplemental: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: 40,
    color: 'rgba(120, 121, 142, 1)',
    fontSize: 14,
    fontStyle: 'normal',
  },

  commentCard: {
    minHeight: 70,
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    boxSizing: 'border-box',
  },
  commentHeaderRow: {
    height: 24,
    display: 'flex',
    gap: 10,
    justifyContent: 'start',
    alignItems: 'center',
    boxSizing: 'border-box',
  },
  commentAvatar: {
    height: 24,
    width: 24,
    fontSize: 11,
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: 'normal',
    backgroundColor: '#5398E6',
    color: '#fff',
  },
  commentMeta: {
    display: 'flex',
    gap: 6,
    justifyContent: 'center',
    alignItems: 'center',
  },
  commentAuthor: {
    fontSize: 14,
    fontWeight: 400,
    color: 'rgba(43, 44, 53, 1)',
    fontStyle: 'normal',
    lineHeight: '21px',
  },
  commentDate: {
    fontSize: 14,
    fontWeight: 400,
    color: 'rgba(120, 121, 142, 1)',
    fontStyle: 'normal',
    lineHeight: '17px',
  },
  commentBodyRow: {
    minHeight: 21,
    display: 'flex',
    justifyContent: 'start',
    alignItems: 'center',
    boxSizing: 'border-box',
  },
  commentBodySpacer: {
    minHeight: 34,
    minWidth: 34,
    boxSizing: 'border-box',
  },
  commentText: {
    fontSize: 14,
    fontWeight: 400,
    color: 'rgba(43, 44, 53, 1)',
    fontStyle: 'normal',
    lineHeight: '17px',
    wordBreak: 'break-word',
  },

  addCommentRow: {
    minHeight: 110,
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    gap: 10,
    justifyContent: 'start',
    alignItems: 'flex-start',
  },
  addCommentBox: {
    width: '100%',
    paddingRight: 10,
    position: 'relative',
  },
  addCommentTextarea: {
    width: '100%',
    height: 100,
    fontSize: 12,
    resize: 'none',
    outline: 'none',
    borderRadius: 4,
    border: '1px solid rgba(224, 224, 224, 1)',
    background: 'rgba(250, 250, 250, 1)',
    padding: '5px 8px 6px 8px',
    boxSizing: 'border-box',
    fontFamily: 'inherit',
  },
  addCommentButton: {
    height: 26,
    padding: '3px 10px',
    color: '#fff',
    borderRadius: 4,
    position: 'absolute',
    top: 65,
    right: '4%',
    fontSize: 12,
    textTransform: 'none',
    '&:hover': {
      backgroundColor: 'rgba(2, 136, 209, 1)',
      borderColor: '#3F51B5',
      boxShadow: 'none',
    },
  },
  addCommentButtonActive: {
    backgroundColor: 'rgba(2, 136, 209, 1)',
  },
  addCommentButtonDisabled: {
    backgroundColor: 'rgba(224, 224, 224, 1)',
  },

  /* ---------- Responsive overrides for the new classes only ---------- */
  '@media (max-width:1024px)': {
    addCommentButton: {
      top: 62,
      right: 8,
    },
  },
  '@media (max-width:768px)': {
    addCommentTextarea: {
      height: 90,
    },
    addCommentButton: {
      top: 'auto',
      bottom: 8,
      right: 8,
    },
  },
  '@media (max-width:600px)': {
    addCommentTextarea: {
      height: 80,
    },
  },

}));

export default useStyles;

